import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import get from 'lodash/get';

interface IInputProps {
  name: string;
  id: string;
  label: string;
  placeholder: string;
  readonly?: boolean;
  disabled?: boolean;
  maxLength?: number;
  defaultValue?: string;
  defaultValueTipo?: string;
  handleOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any;
  req?: any;
  xl?: number;
  md?: number;
  col?: number;
}

const FormInputIPF: React.FC<IInputProps> = ({
  name,
  id,
  label,
  placeholder,
  readonly,
  disabled,
  maxLength,
  req,
  xl = 12,
  md = 12,
  col = 12,
  defaultValue,
  defaultValueTipo
}) => {
  const { register, formState: { errors }, watch, setValue } = useFormContext();

  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null && defaultValue !== "") {
      setValue(name, defaultValue);
    }
    if (defaultValueTipo !== undefined && defaultValueTipo !== null && defaultValueTipo !== "") {
      setValue(name + "Tipo", defaultValueTipo);
    }
  }, []);

  const validateNIE = (value: string) => {
    if (!value) {
      if (!req) return true;
      return typeof req === 'string' ? req : 'Este campo es obligatorio';
    }

    const tipo = watch(name + "Tipo");

    // Validación para DNI
    if (tipo === "1") {
      const regexDNI = /^\d{8}[A-Z]$/;
      if (!regexDNI.test(value)) {
        const regexNIE = /^[XYZ][0-9]{7}[A-Z]$/;
        if (regexNIE.test(value)) {
          return "Parece un NIE, selecciona el tipo correcto.";
        }
        return "El DNI debe tener 8 números y una letra mayúscula";
      }

      const dniNumbers = value.substring(0, 8);
      const dniLetter = value.substring(8, 9);
      const letter = calculateDNIletter(dniNumbers);
      if (letter !== dniLetter) {
        return "La letra no coincide";
      }
    }

    // Validación para NIE
    else if (tipo === "6") {
      const regexNIE = /^[XYZ][0-9]{7}[A-Z]$/;
      if (!regexNIE.test(value)) {
        const regexDNI = /^\d{8}[A-Z]$/;
        if (regexDNI.test(value)) {
          return "Parece un DNI, selecciona el tipo correcto.";
        }
        return "El NIE debe tener 1 letra, 7 números y 1 letra (letras mayúsculas)";
      }

      const initialLetter = value[0];
      if (!["X", "Y", "Z"].includes(initialLetter)) {
        return "La letra inicial del NIE debe ser X, Y o Z";
      }

      const finalLetter = value[8];
      const calculatedLetter = calculateNIEletter(value);
      if (finalLetter !== calculatedLetter) {
        return "La letra final del NIE no coincide";
      }
    }

    // Pasaporte (tipo 2): sin validación de momento
    return true;
  };

  function calculateNIEletter(nie: string): string {
    const nieLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const initialLetter = nie[0];
    const numberPart = nie.substring(1, 8);

    let prefixNumber: string;
    switch (initialLetter) {
      case "X":
        prefixNumber = "0";
        break;
      case "Y":
        prefixNumber = "1";
        break;
      case "Z":
        prefixNumber = "2";
        break;
      default:
        return ""; // Error de entrada
    }

    const fullNumber = prefixNumber + numberPart;
    const index = parseInt(fullNumber, 10) % 23;
    return nieLetters[index];
  }

  function calculateDNIletter(numbers: string): string {
    const dniLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const remainder = parseInt(numbers) % 23;
    return dniLetters[remainder];
  }

  const errorMessage = get(errors, name)?.message;

  return (
    <div className={`col-xl-${xl} col-md-${md} col-${col}`}>
      <fieldset className={`input-block input-block--code ${(errors && errors[name]?.message) ? 'error' : ''}`} disabled={disabled}>
        <legend className="input-block--code__legend">{label}</legend>

        <input
          type="text"
          className='col-xl-12 col-12 col-md-12'
          name={name}
          id={id}
          placeholder={placeholder}
          {...register(name, {
            required: req,
            validate: validateNIE
          })}
          readOnly={readonly || false}
          disabled={disabled}
          maxLength={maxLength}
        />

        <select
          id={name + "Tipo"}
          {...register(name + "Tipo")}
          className='col-xl-12 col-md-12 col-12'
          disabled={disabled}
        >
          <option value="1">DNI</option>
          <option value="6">NIE</option>
          <option value="2">Pasaporte</option>
        </select>

        {errorMessage && <p className="error m-0">{errorMessage}</p>}
      </fieldset>
    </div>
  );
};

export default FormInputIPF;
